/* PARFUMPROBEN VERSAND – Kollektions-Hub (SEO-Paket 11/2026, gehört zu ppv-hub.css):
   Die Einleitung unter der Überschrift ist auf zwei Zeilen gekürzt. „Mehr lesen“ erscheint nur, wenn der Text länger ist. */
(() => {
  if (window.__PPV_HUB__) return;
  window.__PPV_HUB__ = true;

  function init(box) {
    if (box.dataset.ppvHubReady) return;
    box.dataset.ppvHubReady = '1';
    const text = box.querySelector('.ppv-hub-intro__text');
    const button = box.querySelector('.ppv-hub-intro__more');
    if (!text || !button) return;

    const check = () => {
      if (box.classList.contains('is-open')) return;
      button.hidden = text.scrollHeight <= text.clientHeight + 1;
    };

    button.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
      if (!open) check();
    });

    check();
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(text);
    else window.addEventListener('resize', check);
    window.addEventListener('load', check, { once: true });
  }

  const run = () => document.querySelectorAll('[data-ppv-hub-intro]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
